

import { useMessage } from "../context/MessageContext";

import ReactMarkdown from "react-markdown";



interface MessageProps {
  message: IMessage,
}
export default function Message( { message }: MessageProps ) {

  const { highlightedMessageId, highlightedResponseGroupId } = useMessage();

  const hasMarkdown = /[*_~`\[\]>#-]/.test( message.messageText );

  // Highlight if either:
  // 1. This message's ID matches highlightedMessageId (sequential/audio mode)
  // 2. This message's responseGroupId matches highlightedResponseGroupId (instant output mode)
  const isHighlighted = message.id === highlightedMessageId ||
    (message.responseGroupId !== undefined && message.responseGroupId === highlightedResponseGroupId);

  return (
    <div className="chat-message">
      <div className="chat-message_profile">
        <img src={message.profilePicSource} className="chat-message_profile_image" />
      </div>

      <div className="chat-message_content">
        <span className="chat-message_profile_name"><b>{message.profileName}</b></span>

        <p className={`chat-message_text ${isHighlighted ? "highlight" : ""}`}>
          {hasMarkdown ?
              <ReactMarkdown>{message.messageText}</ReactMarkdown>
            :
              message.messageText
          }
        </p>

        { message.attachedFileName ?
            <div className="file-attachment-info">{message.attachedFileName} was uploaded with this message</div>
          :
            <></>
        }
      </div>
    </div>
  );
}


